const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fc705604107e8785c04e40c9b3a792de39bda5a3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gsmtasks-tracker@namespace"]={id:"fc705604107e8785c04e40c9b3a792de39bda5a3"};
      